<template>
  <div class="min-w-[300px]">
    <div v-if="unavailableItems.length > 0" class="flex justify-between items-center">
      <h1 class="text-[16px] font-medium mb-2">Un Available Items</h1>
      <div class="text-[12px] text-[var(--placeholder-color)]">
        <div v-for="(item, index) in unavailableItems" :key="index">
          <RouterLink :to="`/order/${item.orderId}`">
            <div class="flex items-center gap-2">
              <div>
                <i class="pi pi-exclamation-circle" style="font-size: 20px;" />
              </div>
              <div class="flex items-center gap-2">
                <h1 class="text-[14px] font-medium">{{ item.orderId }}</h1>
              </div>
              </div>
          </RouterLink>
          
        </div>
      </div>
    </div>
    <div class="flex justify-between items-center">
      <h1 class="text-[16px] font-medium mb-2">New Messages</h1>
    </div>
    <div class="flex flex-col gap-2 max-h-[500px] overflow-y-auto">
      <div v-if="messages.length === 0">No new messages</div>
      <div v-for="(message, index) in messages" v-else :key="index">
        <div @click="onOpenChat(message)">
          <RouterLink
            :to="
              route.name === 'MonitoringOrder' || route.name === 'MonitoringTwoOrder'
                ? `${route.name === 'MonitoringTwoOrder' ? '/monitoring-two' : '/monitoring'}?userIdChat=${message.senderUserId}`
                : `/chat?userId=${message.senderUserId}`
            "
          >
            <div
              class="min-w-[300px] h-[50px] rounded-md flex items-center px-2 cursor-pointer"
              :class="
                message.isRead && message.senderUserRoleType !== RoleType.PANEL
                  ? ''
                  : 'bg-[var(--revers-contrast-background)]'
              "
            >
              <div
                v-if="!message.isRead && message.senderUserRoleType !== RoleType.PANEL"
                class="absolute -mx-1 -mt-8"
              >
                <div class="w-[8px] h-[8px] rounded-full bg-[#1c92d6]" />
              </div>
              <div class="flex items-center gap-2">
                <div class="">
                  <img
                    class="h-[35px] w-[35px] rounded-full"
                    :src="getImageFullUrl(message.driverPhotoUrl ?? '')"
                  />
                </div>
                <div>
                  <div class="flex gap-1 items-center justify-between w-[250px]">
                    <h1 class="text-[14px] font-medium">{{ message.driverFullName }}</h1>
                    <div class="text-[12px] text-[var(--placeholder-color)]">
                      {{
                        isSameDay(message.createdAt)
                          ? moment(message.createdAt).fromNow()
                          : moment(message.createdAt).format('DD/MM/YYYY HH:mm')
                      }}
                    </div>
                  </div>
                  <p class="text-sm text-[var(--placeholder-color)] truncate max-w-[250px] -mt-1">
                    {{ message.message }}
                  </p>
                </div>
              </div>
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { watch, ref } from 'vue'
import { getImageFullUrl } from '@/utils/getImageFullUrl'
import moment from 'moment'
import { useNotificationStore } from '../../stores/notificationStore'
import type { ChatEntity } from '@/features/chat/domain/entities/ChatEntity'
import { useRoute } from 'vue-router'
import { RoleType } from '@/features/role/domain/enums/RoleType'
import type { UnavailableItemOrderEntity } from '@/features/order/domain/entities/UnavailableItemOrderEntity'
const notificationStore = useNotificationStore()

const messages = ref<ChatEntity[]>([])
const unavailableItems = ref<UnavailableItemOrderEntity[]>([])
const route = useRoute()
const isSameDay = (date?: string) => {
  if (!date) return false
  return moment(date).isSame(moment(), 'day')
}

function onOpenChat(message: ChatEntity) {
  notificationStore.seenMessage(message.senderUserId as string)
}
// function onSeenAllMessages() {
//   notificationStore.seenAllMessages()
// }
watch(
  () => notificationStore.messages,
  () => {
    messages.value = notificationStore.messages
  },
  {
    immediate: true,
    deep: true
  }
)
watch(
  () => notificationStore.unavailableItems,
  () => {
    unavailableItems.value = notificationStore.unavailableItems
  },
  {
    immediate: true,
    deep: true
  }
)
</script>
